import axios from 'axios';

const API = '/api/epayrequest';
const EPAYMENT_DENIED_PAYMENT_ENDING = 'denied';
const EPAYMENT_SUCCESS_PAYMENT_ENDING = 'success';
const EPAYMENT_RECEIPT_DOWNLOAD = 'download';

class EPaymentService {
  async processDenial(parameters) {
    const url = `${API}/${EPAYMENT_DENIED_PAYMENT_ENDING}`;
    const result = await axios.post(url, parameters);
    return result;
  }

  async processSuccess(parameters) {
    const url = `${API}/${EPAYMENT_SUCCESS_PAYMENT_ENDING}`;
    const result = await axios.post(url, parameters);
    return result;
  }

  async downloadReceipt(eReceiptId) {
    var url = `${API}/${EPAYMENT_RECEIPT_DOWNLOAD}/${eReceiptId}`;
    return await axios.post(url, '', {
      responseType: 'blob'
    });
  }
}

export default new EPaymentService();
